import clsx from 'clsx';
import Image from 'next/image';
import warningIcon from '@/assets/icons/warning-icon.svg';
import { Text } from '@/components/Text';
import type { DealDataTypes } from '@/lib/types';
import { DocumentsUploaderForm } from '../DocumentsUploaderForm';
import { NecessaryDocuments } from '../NecessaryDocuments';
import styles from './BuyersDeal.module.scss';
type Props = {
  advertisementAuthor: {
    firstName: string;
    lastName: string;
    patronymic: string;
  };
  advertisementId: string;
  className?: string;
  dealData?: DealDataTypes;
  dealUserType: 'buyer' | 'seller' | null;
};
export const BuyersDeal = ({
  advertisementAuthor,
  advertisementId,
  className,
  dealData,
  dealUserType
}: Props) => {
  return <section className={clsx(styles.wrapper, className)} data-sentry-component="BuyersDeal" data-sentry-source-file="BuyersDeal.tsx">
      <div className={styles.titleWrapper}>
        <Image alt='warningIcon' src={warningIcon} data-sentry-element="Image" data-sentry-source-file="BuyersDeal.tsx" />
        <Text tag='h2' type='h4' data-sentry-element="Text" data-sentry-source-file="BuyersDeal.tsx">
          Завантажте документи
        </Text>
      </div>
      <DocumentsUploaderForm advertisementAuthor={advertisementAuthor} advertisementId={advertisementId} dealData={dealData} dealUserType={dealUserType} data-sentry-element="DocumentsUploaderForm" data-sentry-source-file="BuyersDeal.tsx" />
      <NecessaryDocuments data-sentry-element="NecessaryDocuments" data-sentry-source-file="BuyersDeal.tsx" />
    </section>;
};